/*
 * Jira Ticket:
 * Created Date: Wed, 11th Mar 2020, 16:54:04 pm
 * Author: Jessica Mowatt
 * Email: jessica.mowatt@thedistance.co.uk
 * Copyright (c) 2020 The Distance
 */

import React from 'react';
import { ReferenceInput, SelectInput, useTranslate, Filter } from 'react-admin';

const SubcontractorFilters = ({
  organisationFilter,
  organisationId,
  ...props
}) => {
  const translate = useTranslate();

  return (
    // Note: we do not use the Filters component here as we would
    // be hitting errors nesting forms inside forms
    <Filter {...props}>
      <ReferenceInput
        label={translate('resources.Organisation.name', { smart_count: 1 })}
        source="organisationId"
        reference="Organisation"
        emptyText={translate('resources.Subcontractor.noOrganisations')}
        perPage={1000}
        sort={{ field: 'name', order: 'ASC' }}
        onChange={organisationFilter}
        alwaysOn
      >
        <SelectInput
          source="id"
          optionText="name"
          options={{
            InputLabelProps: { shrink: true },
            SelectProps: { displayEmpty: true },
          }}
        />
      </ReferenceInput>
      <ReferenceInput
        label={translate('resources.Subcontractor.name', { smart_count: 1 })}
        source="subcontractorId"
        reference="Organisation"
        perPage={1000}
        sort={{ field: 'name', order: 'ASC' }}
      >
        <SelectInput source="id" optionText="name" />
      </ReferenceInput>
      <ReferenceInput
        label={'resources.Subcontractor.fields.project'}
        source="projectId"
        reference="Project"
        filter={{ principalOrganisationId: organisationId }}
        perPage={1000}
        sort={{ field: 'name', order: 'ASC' }}
      >
        <SelectInput
          source="id"
          optionText="name"
          disabled={organisationId ? false : true}
        />
      </ReferenceInput>
    </Filter>
  );
};

export default SubcontractorFilters;
